import React from 'react';
import { LucideIcon } from 'lucide-react';

interface StatCardProps {
  value: string | number;
  label: string;
  icon?: LucideIcon;
  trend?: {
    value: string;
    isPositive: boolean;
  };
  className?: string;
}

export function StatCard({ value, label, icon: Icon, trend, className = '' }: StatCardProps) {
  return (
    <div role="group" aria-label={label} className={`bg-[--clinqr-bg-subtle] rounded-xl p-6 shadow-sm border border-[--clinqr-border] ${className}`}>
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <p className="text-[--clinqr-text-secondary] mb-2">
            {label}
          </p>
          <p className="text-[--clinqr-text-primary] text-2xl font-semibold">
            {value}
          </p>
          {trend && (
            <div className="flex items-center gap-1 mt-2">
              <span className={trend.isPositive ? 'text-[--clinqr-text-primary] font-medium' : 'text-[--clinqr-error]'}>
                {trend.isPositive ? '↑' : '↓'} {trend.value}
              </span>
            </div>
          )}
        </div>
        {Icon && (
          <div className="w-12 h-12 rounded-xl bg-[--clinqr-primary] flex items-center justify-center">
            <Icon className="w-6 h-6 text-[--clinqr-bg]" strokeWidth={2} />
          </div>
        )}
      </div>
    </div>
  );
}
